import { request } from '@/shared/api/request'
const headers = {
	'Content-Type': 'text/plain',
}
export const getAidXml = (data) => request({ url: `/contract/aid/xmlReq`, method: 'POST', data, headers })
